import React, { useState } from 'react';
import { Alert, AlertTitle, Box, Button, Typography } from '@mui/material';

/**
 * Componente de alerta melhorado que exibe mensagens de erro mais detalhadas
 * @param {Object} props - Propriedades do componente
 * @param {string} props.severity - Tipo de alerta (error, warning, info, success)
 * @param {string} props.title - Título do alerta
 * @param {string} props.message - Mensagem principal do alerta
 * @param {string} props.details - Detalhes adicionais do erro (opcional)
 */
const EnhancedAlert = ({ severity, title, message, details }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Alert
      severity={severity}
      sx={{ mb: 3, mt: 3 }}
      action={
        details && (
          <Button
            color="inherit"
            size="small"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? 'Menos detalhes' : 'Mais detalhes'}
          </Button>
        )
      }
    >
      <AlertTitle>{title}</AlertTitle>
      {message}
      {expanded && details && (
        <Box mt={1} p={1} bgcolor="rgba(0,0,0,0.04)" borderRadius={1}>
          <Typography variant="body2" component="pre" style={{ whiteSpace: 'pre-wrap' }}>
            {details}
          </Typography>
        </Box>
      )}
    </Alert>
  );
};

export default EnhancedAlert;